import {
  m6 as objectMeta,
  ga as VOID,
  o6 as setMetadataFor,
  h2 as emptyList,
  p5 as classMeta,
  f2 as copyToArray,
  a1 as Unit_getInstance,
  e1 as ArrayList,
  a2 as collectionSizeOrDefault,
  z5 as interfaceMeta,
  j1 as LinkedHashMap,
  s9 as THROW_CCE,
  g6 as isObject,
  r9 as RuntimeException,
  q7 as isBlank,
  y9 as ensureNotNull,
  b3 as listOf,
  s3 as plus,
  d3 as mapCapacity,
  u6 as coerceAtLeast,
  q9 as Pair,
  h4 as toMutableMap,
  e6 as isInterface,
  t1 as Set,
  y2 as last,
  z1 as checkIndexOverflow,
  c4 as toList,
  m2 as firstOrNull,
  t2 as joinToString,
} from './kotlin-kotlin-stdlib.mjs';
import {
  h as Agl_getInstance,
  v7 as AglStyleSelector,
  c as AglStyleSelectorKind_LITERAL_getInstance,
  s7 as AglStyleRule,
  w7 as AglStyle,
  l7 as SentenceContext,
} from './net.akehurst.language-agl-processor.mjs';
import {
  u as AglEditorJsAbstract,
  d as Companion_getInstance,
  y as AglTokenizer,
  v as AglLineState,
  x as AglTokenizerByWorker,
} from './net.akehurst.language.editor-agl-editor-common.mjs';
import {
  b as removeClass,
  a as addClass,
} from './kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class BuildConfig_0 {
  constructor() {
    BuildConfig_instance = this;
    this.version = '1.9.20-Beta';
    this.buildStamp = '2023-09-29T11:11:46.834365Z[UTC]';
    this.buildDate = '2023-Sept-29';
    this.buildTime = '11:11:46 UTC';
  }
  nt() {
    return this.version;
  }
  ot() {
    return this.buildStamp;
  }
  pt() {
    return this.buildDate;
  }
  qt() {
    return this.buildTime;
  }
}
class AglCompletionProviderMonaco$provideCompletionItems$cil$1$1 {
  constructor($ci) {
    this.v4t_1 = $ci.text + ' (' + $ci.name + ')';
    this.w4t_1 = $ci.text;
    this.x4t_1 = CompletionItemKind.Text;
  }
  y4t() {
    return this.v4t_1;
  }
  z4t() {
    return this.w4t_1;
  }
  v2k() {
    return this.x4t_1;
  }
  get label() {
    return this.y4t();
  }
  get insertText() {
    return this.z4t();
  }
  get kind() {
    return this.v2k();
  }
}
class AglCompletionProviderMonaco$provideCompletionItems$1 {
  constructor($cil) {
    this.a4u_1 = false;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp$ret$0 = copyToArray($cil);
    tmp.b4u_1 = tmp$ret$0;
  }
  c4u() {
    return this.a4u_1;
  }
  d4u() {
    return this.b4u_1;
  }
  get incomplete() {
    return this.c4u();
  }
  get suggestions() {
    return this.d4u();
  }
}
class AglCompletionProviderMonaco {
  constructor(agl) {
    this.agl = agl;
    this.u4t_1 = null;
  }
  c25() {
    return this.agl;
  }
  e4u() {
    return this.u4t_1;
  }
  f4u(model, position, context, token) {
    var posn = model.getOffsetAt(position);
    var wordList = getCompletionItems(this, model, posn);
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(wordList, 10));
    var tmp0_iterator = wordList.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.editor.browser.monaco.AglCompletionProviderMonaco.provideCompletionItems.<anonymous>' call
      tmp$ret$0 = new AglCompletionProviderMonaco$provideCompletionItems$cil$1$1(item);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    var cil = tmp$ret$2;
    return new AglCompletionProviderMonaco$provideCompletionItems$1(cil);
  }
  provideCompletionItems(model, position, context, token) {
    return this.f4u(model, position, context, token);
  }
  g4u(model, position, item, token) {
    return null;
  }
  resolveCompletionItem(model, position, item, token) {
    return this.g4u(model, position, item, token);
  }
  get triggerCharacters() {
    return this.e4u();
  }
}
class Monaco {}
class Companion {
  constructor() {
    Companion_instance = this;
    this.h4u_1 = function () {
      var self = {MonacoEnvironment: {}};
      return self.MonacoEnvironment = {getWorkerUrl: function (moduleId, label) {
        return './main.js';
      }};
    }.call(this);
    this.i4u_1 = 'agl-theme';
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.allAglGlobalThemeRules = tmp$ret$0;
  }
  j4u() {
    return this.allAglGlobalThemeRules;
  }
}
class AglEditorMonaco extends AglEditorJsAbstract {
  constructor(containerElement, monacoEditor, languageId, editorId, logFunction, worker, monaco) {
    Companion_getInstance_0();
    super(languageId, editorId, logFunction, worker);
    this.q4u_1 = containerElement;
    this.r4u_1 = monacoEditor;
    this.s4u_1 = monaco;
    this.t4u_1 = this.languageIdentity + '-';
    this.u4u_1 = null;
    init_(this);
  }
  x4c() {
    return this.r4u_1;
  }
  k4n() {
    return 'none';
  }
  g4d(value) {
    try {
      this.r4u_1.getModel().setValue(value);
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        throw RuntimeException.u6('Failed to set text in editor');
      } else {
        throw $p;
      }
    }
  }
  u1p() {
    try {
      return this.r4u_1.getModel().getValue();
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        throw RuntimeException.u6('Failed to get text from editor');
      } else {
        throw $p;
      }
    }
  }
  destroy() {
  }
  updateLanguage(oldId) {
    if (!(null == oldId)) {
      var oldAglStyleClass = Companion_getInstance().languageIdToStyleClass(this.agl.styleHandler.cssClassPrefixStart, oldId);
      removeClass(this.q4u_1, [oldAglStyleClass]);
    }
    addClass(this.q4u_1, [this.agl.styleHandler.aglStyleClass]);
  }
  configureSyntaxAnalyser(configuration) {
    this.aglWorker.configureSyntaxAnalyser(this.languageIdentity, this.editorId, '', configuration);
  }
  updateStyle() {
    if (this.q4u_1.isConnected) {
      var aglStyleClass = this.agl.styleHandler.aglStyleClass;
      var styleStr = this.editorSpecificStyleStr;
      var tmp;
      if (!(null == styleStr)) {
        var tmp$ret$0;
        // Inline function 'kotlin.text.isNotBlank' call
        tmp$ret$0 = !isBlank(styleStr);
        tmp = tmp$ret$0;
      } else {
        tmp = false;
      }
      if (tmp) {
        this.agl.styleHandler.reset();
        var styleMdl = ensureNotNull(Agl_getInstance().registry.agl.style.processor).process(styleStr).asm;
        if (!(null == styleMdl)) {
          var mappedCss = '';
          // Inline function 'kotlin.collections.forEach' call
          var tmp0_forEach = styleMdl.rules;
          var tmp0_iterator = tmp0_forEach.u();
          while (tmp0_iterator.h1()) {
            var element = tmp0_iterator.j1();
            // Inline function 'net.akehurst.language.editor.browser.monaco.AglEditorMonaco.updateStyle.<anonymous>' call
            var tmp$ret$3;
            // Inline function 'kotlin.collections.map' call
            var tmp0_map = element.selector;
            var tmp$ret$2;
            // Inline function 'kotlin.collections.mapTo' call
            var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
            var tmp0_iterator_0 = tmp0_map.u();
            while (tmp0_iterator_0.h1()) {
              var item = tmp0_iterator_0.j1();
              var tmp$ret$1;
              // Inline function 'net.akehurst.language.editor.browser.monaco.AglEditorMonaco.updateStyle.<anonymous>.<anonymous>' call
              var mappedSelName = this.agl.styleHandler.mapClass(item.value);
              tmp$ret$1 = new AglStyleSelector('.monaco_' + mappedSelName, item.kind);
              tmp0_mapTo.e1(tmp$ret$1);
            }
            tmp$ret$2 = tmp0_mapTo;
            tmp$ret$3 = tmp$ret$2;
            var ruleClasses = tmp$ret$3;
            var cssClasses = plus(listOf(new AglStyleSelector('.' + aglStyleClass, AglStyleSelectorKind_LITERAL_getInstance())), ruleClasses);
            var mappedRule = new AglStyleRule(cssClasses);
            var tmp_0 = mappedRule;
            var tmp$ret$6;
            // Inline function 'kotlin.collections.associate' call
            var tmp1_associate = element.styles.k3();
            var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp1_associate, 10)), 16);
            var tmp$ret$5;
            // Inline function 'kotlin.collections.associateTo' call
            var tmp0_associateTo = LinkedHashMap.o8(capacity);
            var tmp0_iterator_1 = tmp1_associate.u();
            while (tmp0_iterator_1.h1()) {
              var element_0 = tmp0_iterator_1.j1();
              // Inline function 'kotlin.collections.plusAssign' call
              var tmp$ret$4;
              // Inline function 'net.akehurst.language.editor.browser.monaco.AglEditorMonaco.updateStyle.<anonymous>.<anonymous>' call
              var tmp0_subject = element_0.name;
              var tmp_1;
              switch (tmp0_subject) {
                case 'foreground':
                  tmp_1 = new AglStyle('color', element_0.value);
                  break;
                case 'background':
                  tmp_1 = new AglStyle('background-color', element_0.value);
                  break;
                case 'font-style':
                  var tmp1_subject = element_0.value;
                  switch (tmp1_subject) {
                    case 'bold':
                      tmp_1 = new AglStyle('font-weight', element_0.value);
                      break;
                    case 'italic':
                      tmp_1 = new AglStyle('font-style', element_0.value);
                      break;
                    default:
                      tmp_1 = element_0;
                      break;
                  }

                  break;
                default:
                  tmp_1 = element_0;
                  break;
              }
              var style = tmp_1;
              tmp$ret$4 = new Pair(style.name, style);
              var tmp0_plusAssign = tmp$ret$4;
              tmp0_associateTo.m3(tmp0_plusAssign.ri_1, tmp0_plusAssign.si_1);
            }
            tmp$ret$5 = tmp0_associateTo;
            tmp$ret$6 = tmp$ret$5;
            tmp_0.styles = toMutableMap(tmp$ret$6);
            mappedCss = mappedCss + '\n' + mappedRule.toCss();
          }
          var cssText = mappedCss;
          var tmp_2 = this.q4u_1.getRootNode();
          var curStyle = (isObject(tmp_2) ? tmp_2 : THROW_CCE()).querySelector('style#' + this.languageIdentity);
          var tmp0_safe_receiver = curStyle;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.remove();
          }
          var tmp1_safe_receiver = this.q4u_1.ownerDocument;
          var styleElement = ensureNotNull(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.createElement('style'));
          styleElement.setAttribute('id', this.languageIdentity);
          styleElement.textContent = cssText;
          var tmp2_safe_receiver = this.q4u_1.ownerDocument;
          var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.querySelector('head');
          if (tmp3_safe_receiver == null)
            null;
          else
            tmp3_safe_receiver.appendChild(styleElement);
          this.aglWorker.setStyle(this.languageIdentity, this.editorId, '', styleStr);
          update(this);
          this.resetTokenization();
        } else {
        }
      }
    }
  }
  clearErrorMarkers() {
    var tmp = this.r4u_1.getModel();
    var tmp$ret$0;
    // Inline function 'kotlin.emptyArray' call
    tmp$ret$0 = [];
    this.s4u_1.setModelMarkers(tmp, '', tmp$ret$0);
  }
  v4u(handler) {
    this.r4u_1.onDidChangeModelContent(AglEditorMonaco$onChange$lambda(this, handler));
  }
  resetTokenization() {
    this.r4u_1.getModel().resetTokenization();
  }
  processSentence() {
    if (this.doUpdate) {
      this.clearErrorMarkers();
      this.aglWorker.interrupt(this.languageIdentity, this.editorId, '');
      var tmp = this.aglWorker;
      var tmp_0 = this.languageIdentity;
      var tmp_1 = this.agl.goalRule;
      var tmp_2 = this.u1p();
      var tmp_3 = this.agl.context;
      tmp.processSentence(tmp_0, this.editorId, '', tmp_1, tmp_2, (tmp_3 == null ? true : isInterface(tmp_3, SentenceContext)) ? tmp_3 : THROW_CCE());
    }
  }
  createIssueMarkers(issues) {
    var tmp$ret$4;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var tmp0_mapNotNullTo = ArrayList.i4();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = issues.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$1;
      // Inline function 'net.akehurst.language.editor.browser.monaco.AglEditorMonaco.createIssueMarkers.<anonymous>' call
      var errMsg = null;
      var tmp0_subject = element.phase;
      var tmp0 = tmp0_subject.bc_1;
      switch (tmp0) {
        case 0:
          ;
          break;
        case 1:
          var tmp = element.data;
          var expected = (tmp == null ? true : isInterface(tmp, Set)) ? tmp : THROW_CCE();
          errMsg = null == expected ? 'Syntax Error' : expected.y() ? 'Syntax Error' : 1 === expected.o() ? 'Syntax Error, expected: ' + expected : 'Syntax Error, expected one of: ' + expected;
          break;
        case 2:
          errMsg = 'Error ' + element.message;
          break;
        case 3:
          errMsg = 'Error ' + element.message;
          break;
        case 6:
          errMsg = 'Error ' + element.message;
          break;
        case 4:
          errMsg = 'Error ' + element.message;
          break;
        case 5:
          errMsg = 'Error ' + element.message;
          break;
        case 7:
          errMsg = 'Error ' + element.message;
          break;
      }
      var tmp_0;
      if (!(null == errMsg)) {
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.editor.common.objectJSTyped' call
        var o = {};
        // Inline function 'net.akehurst.language.editor.browser.monaco.AglEditorMonaco.createIssueMarkers.<anonymous>.<anonymous>' call
        var tmp0_anonymous = o;
        tmp0_anonymous.code = null;
        tmp0_anonymous.severity = MarkerSeverity.Error;
        var tmp0_safe_receiver = element.location;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.line;
        tmp0_anonymous.startLineNumber = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        var tmp2_safe_receiver = element.location;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.column;
        tmp0_anonymous.startColumn = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
        var tmp4_safe_receiver = element.location;
        var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.line;
        tmp0_anonymous.endLineNumber = tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs;
        var tmp6_safe_receiver = element.location;
        var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.column;
        tmp0_anonymous.endColumn = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
        tmp0_anonymous.message = errMsg;
        tmp0_anonymous.source = null;
        tmp$ret$0 = o;
        tmp_0 = tmp$ret$0;
      } else {
        tmp_0 = null;
      }
      tmp$ret$1 = tmp_0;
      var tmp0_safe_receiver_0 = tmp$ret$1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        var tmp$ret$2;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_mapNotNullTo.e1(tmp0_safe_receiver_0);
        tmp$ret$2 = Unit_getInstance();
      }
    }
    tmp$ret$3 = tmp0_mapNotNullTo;
    tmp$ret$4 = tmp$ret$3;
    var monIssues = tmp$ret$4;
    var tmp_1 = this.r4u_1.getModel();
    var tmp$ret$5;
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp$ret$5 = copyToArray(monIssues);
    this.s4u_1.setModelMarkers(tmp_1, '', tmp$ret$5);
  }
}
class AglLineStateMonaco {
  constructor(lineNumber, leftOverText) {
    this.lineNumber = lineNumber;
    this.leftOverText = leftOverText;
  }
  v4n() {
    return this.lineNumber;
  }
  w4n() {
    return this.leftOverText;
  }
  w4u() {
    return new AglLineStateMonaco(this.lineNumber, this.leftOverText);
  }
  clone() {
    return this.w4u();
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (tmp0_subject instanceof AglLineStateMonaco) {
      tmp = other.lineNumber === this.lineNumber;
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class AglTokenMonaco {
  constructor(style, column) {
    this.x4u_1 = style;
    this.y4u_1 = column - 1 | 0;
  }
  g1n() {
    return this.x4u_1;
  }
  z4u() {
    return this.y4u_1;
  }
  get scopes() {
    return this.g1n();
  }
  get startIndex() {
    return this.z4u();
  }
}
class AglLineTokensMonaco {
  constructor(endState, tokens) {
    this.a4v_1 = endState;
    this.b4v_1 = tokens;
  }
  c4v() {
    return this.a4v_1;
  }
  x4n() {
    return this.b4v_1;
  }
  get endState() {
    return this.c4v();
  }
  get tokens() {
    return this.x4n();
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
  }
  NO_TOKENS(nextLineNumber) {
    var tmp = new AglLineStateMonaco(nextLineNumber, '');
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [new AglTokenMonaco('', 0)];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return new AglLineTokensMonaco(tmp, tmp$ret$2);
  }
}
class AglTokenProvider$getLineTokensByScan$tokens$1$1 {
  constructor(this$0, $leaf) {
    this.d4v_1 = this$0.tokenPrefix + $leaf.name;
    this.e4v_1 = $leaf.location.column - 1 | 0;
  }
  g1n() {
    return this.d4v_1;
  }
  z4u() {
    return this.e4v_1;
  }
  get scopes() {
    return this.g1n();
  }
  get startIndex() {
    return this.z4u();
  }
}
class AglTokenProvider$getLineTokensByScan$1 {
  constructor($endState, $tokens) {
    this.f4v_1 = $endState;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp$ret$0 = copyToArray($tokens);
    tmp.g4v_1 = tmp$ret$0;
  }
  c4v() {
    return this.f4v_1;
  }
  x4n() {
    return this.g4v_1;
  }
  get endState() {
    return this.c4v();
  }
  get tokens() {
    return this.x4n();
  }
}
class AglTokenProvider {
  constructor(tokenPrefix, agl) {
    Companion_getInstance_1();
    this.tokenPrefix = tokenPrefix;
    this.agl = agl;
  }
  h4v() {
    return this.tokenPrefix;
  }
  c25() {
    return this.agl;
  }
  i4v() {
    return new AglLineStateMonaco(0, '');
  }
  getInitialState() {
    return this.i4v();
  }
  j4v(line, state) {
    try {
      if (null == this.agl.sppt) {
        return getLineTokensByScan(this, line, state);
      } else {
        return getLineTokensByParse(this, line, state);
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        console.error(t.message);
        var tmp = Companion_getInstance_1();
        return tmp.NO_TOKENS((state instanceof AglLineStateMonaco ? state : THROW_CCE()).lineNumber + 1 | 0);
      } else {
        throw $p;
      }
    }
  }
  tokenize(line, state) {
    return this.j4v(line, state);
  }
  static get Companion() {
    return Companion_getInstance_1();
  }
}
class ModelDecorationOptions {
  constructor(afterContentClassName, beforeContentClassName, className, glyphMarginClassName, glyphMarginHoverMessage, hoverMessage, inlineClassName, inlineClassNameAffectsLetterSpacing, isWholeLine, linesDecorationsClassName, marginClassName, minimap, overviewRuler, stickiness, zindex) {
    afterContentClassName = afterContentClassName === VOID ? null : afterContentClassName;
    beforeContentClassName = beforeContentClassName === VOID ? null : beforeContentClassName;
    className = className === VOID ? null : className;
    glyphMarginClassName = glyphMarginClassName === VOID ? null : glyphMarginClassName;
    glyphMarginHoverMessage = glyphMarginHoverMessage === VOID ? null : glyphMarginHoverMessage;
    hoverMessage = hoverMessage === VOID ? null : hoverMessage;
    inlineClassName = inlineClassName === VOID ? null : inlineClassName;
    inlineClassNameAffectsLetterSpacing = inlineClassNameAffectsLetterSpacing === VOID ? null : inlineClassNameAffectsLetterSpacing;
    isWholeLine = isWholeLine === VOID ? null : isWholeLine;
    linesDecorationsClassName = linesDecorationsClassName === VOID ? null : linesDecorationsClassName;
    marginClassName = marginClassName === VOID ? null : marginClassName;
    minimap = minimap === VOID ? null : minimap;
    overviewRuler = overviewRuler === VOID ? null : overviewRuler;
    stickiness = stickiness === VOID ? null : stickiness;
    zindex = zindex === VOID ? null : zindex;
    this.k4v_1 = afterContentClassName;
    this.l4v_1 = beforeContentClassName;
    this.m4v_1 = className;
    this.n4v_1 = glyphMarginClassName;
    this.o4v_1 = glyphMarginHoverMessage;
    this.p4v_1 = hoverMessage;
    this.q4v_1 = inlineClassName;
    this.r4v_1 = inlineClassNameAffectsLetterSpacing;
    this.s4v_1 = isWholeLine;
    this.t4v_1 = linesDecorationsClassName;
    this.u4v_1 = marginClassName;
    this.v4v_1 = minimap;
    this.w4v_1 = overviewRuler;
    this.x4v_1 = stickiness;
    this.y4v_1 = zindex;
  }
  z4v(_set____db54di) {
    this.k4v_1 = _set____db54di;
  }
  a4w() {
    return this.k4v_1;
  }
  b4w(_set____db54di) {
    this.l4v_1 = _set____db54di;
  }
  c4w() {
    return this.l4v_1;
  }
  d4w(_set____db54di) {
    this.m4v_1 = _set____db54di;
  }
  e4w() {
    return this.m4v_1;
  }
  f4w(_set____db54di) {
    this.n4v_1 = _set____db54di;
  }
  g4w() {
    return this.n4v_1;
  }
  h4w(_set____db54di) {
    this.o4v_1 = _set____db54di;
  }
  i4w() {
    return this.o4v_1;
  }
  j4w(_set____db54di) {
    this.p4v_1 = _set____db54di;
  }
  k4w() {
    return this.p4v_1;
  }
  l4w(_set____db54di) {
    this.q4v_1 = _set____db54di;
  }
  m4w() {
    return this.q4v_1;
  }
  n4w(_set____db54di) {
    this.r4v_1 = _set____db54di;
  }
  o4w() {
    return this.r4v_1;
  }
  p4w(_set____db54di) {
    this.s4v_1 = _set____db54di;
  }
  q4w() {
    return this.s4v_1;
  }
  r4w(_set____db54di) {
    this.t4v_1 = _set____db54di;
  }
  s4w() {
    return this.t4v_1;
  }
  t4w(_set____db54di) {
    this.u4v_1 = _set____db54di;
  }
  u4w() {
    return this.u4v_1;
  }
  v4w(_set____db54di) {
    this.v4v_1 = _set____db54di;
  }
  w4w() {
    return this.v4v_1;
  }
  x4w(_set____db54di) {
    this.w4v_1 = _set____db54di;
  }
  y4w() {
    return this.w4v_1;
  }
  z4w(_set____db54di) {
    this.x4v_1 = _set____db54di;
  }
  a4x() {
    return this.x4v_1;
  }
  b4x(_set____db54di) {
    this.y4v_1 = _set____db54di;
  }
  c4x() {
    return this.y4v_1;
  }
  get afterContentClassName() {
    return this.a4w();
  }
  set afterContentClassName(value) {
    this.z4v(value);
  }
  get beforeContentClassName() {
    return this.c4w();
  }
  set beforeContentClassName(value) {
    this.b4w(value);
  }
  get className() {
    return this.e4w();
  }
  set className(value) {
    this.d4w(value);
  }
  get glyphMarginClassName() {
    return this.g4w();
  }
  set glyphMarginClassName(value) {
    this.f4w(value);
  }
  get glyphMarginHoverMessage() {
    return this.i4w();
  }
  set glyphMarginHoverMessage(value) {
    this.h4w(value);
  }
  get hoverMessage() {
    return this.k4w();
  }
  set hoverMessage(value) {
    this.j4w(value);
  }
  get inlineClassName() {
    return this.m4w();
  }
  set inlineClassName(value) {
    this.l4w(value);
  }
  get inlineClassNameAffectsLetterSpacing() {
    return this.o4w();
  }
  set inlineClassNameAffectsLetterSpacing(value) {
    this.n4w(value);
  }
  get isWholeLine() {
    return this.q4w();
  }
  set isWholeLine(value) {
    this.p4w(value);
  }
  get linesDecorationsClassName() {
    return this.s4w();
  }
  set linesDecorationsClassName(value) {
    this.r4w(value);
  }
  get marginClassName() {
    return this.u4w();
  }
  set marginClassName(value) {
    this.t4w(value);
  }
  get minimap() {
    return this.w4w();
  }
  set minimap(value) {
    this.v4w(value);
  }
  get overviewRuler() {
    return this.y4w();
  }
  set overviewRuler(value) {
    this.x4w(value);
  }
  get stickiness() {
    return this.a4x();
  }
  set stickiness(value) {
    this.z4w(value);
  }
  get zindex() {
    return this.c4x();
  }
  set zindex(value) {
    this.b4x(value);
  }
}
class AglTokenizerByWorkerMonaco {
  constructor(monacoEditor, agl) {
    this.d4x_1 = monacoEditor;
    this.e4x_1 = agl;
    this.f4x_1 = new AglTokenizer(this.e4x_1);
    this.g4x_1 = false;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.h4x_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.i4x_1 = tmp$ret$1;
  }
  s4n(_set____db54di) {
    this.g4x_1 = _set____db54di;
  }
  t4n() {
    return this.g4x_1;
  }
  u4n() {
    return this.h4x_1;
  }
  reset() {
    this.g4x_1 = false;
    this.h4x_1.n1();
  }
  receiveTokens(tokens) {
    if (this.g4x_1) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var tmp0_iterator = tokens.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.editor.browser.monaco.AglTokenizerByWorkerMonaco.receiveTokens.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var tmp0_anonymous = checkIndexOverflow(tmp1);
        // Inline function 'kotlin.collections.set' call
        var tmp0_set = this.h4x_1;
        var tmp1_set = toList(item);
        tmp0_set.m3(tmp0_anonymous, tmp1_set);
      }
    }
  }
  i4v() {
    return new AglLineStateMonaco(0, '');
  }
  getInitialState() {
    return this.i4v();
  }
  j4v(line, pState) {
    var mcState = pState instanceof AglLineStateMonaco ? pState : THROW_CCE();
    var row = mcState.lineNumber + 1 | 0;
    var tokens = this.h4x_1.u3(row - 1 | 0);
    var tmp;
    if (null == tokens) {
      var stateAgl = new AglLineState(mcState.lineNumber, mcState.leftOverText, emptyList());
      var ltokens = this.f4x_1.getLineTokensByScan(line, stateAgl, row);
      this.j4x(row, ltokens.tokens);
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp0_map = ltokens.tokens;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
      var tmp0_iterator = tmp0_map.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.editor.browser.monaco.AglTokenizerByWorkerMonaco.tokenize.<anonymous>' call
        var tmp0_elvis_lhs = firstOrNull(item.styles);
        tmp$ret$0 = new AglTokenMonaco(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, item.column);
        tmp0_mapTo.e1(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      var lineTokens = tmp$ret$2;
      var tmp$ret$3;
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp$ret$3 = copyToArray(lineTokens);
      var lt = tmp$ret$3;
      tmp = new AglLineTokensMonaco(new AglLineStateMonaco(row, ''), lt);
    } else {
      this.j4x(row, tokens);
      var tmp$ret$6;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$5;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(tokens, 10));
      var tmp0_iterator_0 = tokens.u();
      while (tmp0_iterator_0.h1()) {
        var item_0 = tmp0_iterator_0.j1();
        var tmp$ret$4;
        // Inline function 'net.akehurst.language.editor.browser.monaco.AglTokenizerByWorkerMonaco.tokenize.<anonymous>' call
        var tmp0_elvis_lhs_0 = firstOrNull(item_0.styles);
        tmp$ret$4 = new AglTokenMonaco(tmp0_elvis_lhs_0 == null ? '' : tmp0_elvis_lhs_0, item_0.column);
        tmp0_mapTo_0.e1(tmp$ret$4);
      }
      tmp$ret$5 = tmp0_mapTo_0;
      tmp$ret$6 = tmp$ret$5;
      var lineTokens_0 = tmp$ret$6;
      var tmp$ret$7;
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp$ret$7 = copyToArray(lineTokens_0);
      var lt_0 = tmp$ret$7;
      tmp = new AglLineTokensMonaco(new AglLineStateMonaco(row, ''), lt_0);
    }
    return tmp;
  }
  tokenize(line, state) {
    return this.j4v(line, state);
  }
  j4x(lineNum, tokens) {
    var tmp$ret$5;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$4;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tokens, 10));
    var tmp0_iterator = tokens.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$2;
      // Inline function 'net.akehurst.language.editor.browser.monaco.AglTokenizerByWorkerMonaco.decorateLine.<anonymous>' call
      var tmp$ret$1;
      // Inline function 'net.akehurst.language.editor.common.objectJSTyped' call
      var o = {};
      // Inline function 'net.akehurst.language.editor.browser.monaco.AglTokenizerByWorkerMonaco.decorateLine.<anonymous>.<anonymous>' call
      var tmp0_anonymous = o;
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.editor.common.objectJSTyped' call
      var o_0 = {};
      // Inline function 'net.akehurst.language.editor.browser.monaco.AglTokenizerByWorkerMonaco.decorateLine.<anonymous>.<anonymous>.<anonymous>' call
      var tmp0_anonymous_0 = o_0;
      tmp0_anonymous_0.startColumn = item.column;
      tmp0_anonymous_0.endColumn = item.column + item.value.length | 0;
      tmp0_anonymous_0.startLineNumber = item.line;
      tmp0_anonymous_0.endLineNumber = item.line;
      tmp$ret$0 = o_0;
      tmp0_anonymous.range = tmp$ret$0;
      tmp0_anonymous.options = new ModelDecorationOptions(VOID, VOID, VOID, VOID, VOID, VOID, joinToString(item.styles, ' ', VOID, VOID, VOID, VOID, AglTokenizerByWorkerMonaco$decorateLine$lambda));
      tmp$ret$1 = o;
      tmp$ret$2 = tmp$ret$1;
      tmp0_mapTo.e1(tmp$ret$2);
    }
    tmp$ret$3 = tmp0_mapTo;
    tmp$ret$4 = tmp$ret$3;
    var tmp0_toTypedArray = tmp$ret$4;
    tmp$ret$5 = copyToArray(tmp0_toTypedArray);
    var decs = tmp$ret$5;
    var tmp0_elvis_lhs = this.i4x_1.u3(lineNum);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp$ret$6;
      // Inline function 'kotlin.emptyArray' call
      tmp$ret$6 = [];
      tmp = tmp$ret$6;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var curDes = tmp;
    var d = this.d4x_1.deltaDecorations(curDes, decs);
    // Inline function 'kotlin.collections.set' call
    var tmp1_set = this.i4x_1;
    tmp1_set.m3(lineNum, d);
  }
  get acceptingTokens() {
    return this.t4n();
  }
  set acceptingTokens(value) {
    this.s4n(value);
  }
  get tokensByLine() {
    return this.u4n();
  }
}
//endregion
var BuildConfig_instance;
function BuildConfig_getInstance() {
  if (BuildConfig_instance === VOID)
    new BuildConfig_0();
  return BuildConfig_instance;
}
function getCompletionItems($this, model, offset) {
  var text = model.getValue();
  var proc = $this.agl.languageDefinition.processor;
  var goalRule = $this.agl.goalRule;
  var tmp;
  if (null == proc) {
    tmp = emptyList();
  } else {
    var tmp_0 = Agl_getInstance();
    var result = proc.expectedItemsAt(text, offset, 1, tmp_0.options(AglCompletionProviderMonaco$getCompletionItems$lambda(goalRule)));
    tmp = result.items;
  }
  return tmp;
}
function AglCompletionProviderMonaco$getCompletionItems$lambda$lambda($goalRule) {
  return function ($this$parse) {
    $this$parse.goalRuleName($goalRule);
    return Unit_getInstance();
  };
}
function AglCompletionProviderMonaco$getCompletionItems$lambda($goalRule) {
  return function ($this$options) {
    $this$options.parse(AglCompletionProviderMonaco$getCompletionItems$lambda$lambda($goalRule));
    return Unit_getInstance();
  };
}
function attachToMonaco(_this__u8e3s4, containerElement, monacoEditor, languageId, editorId, logFunction, worker, monaco) {
  return new AglEditorMonaco(containerElement, monacoEditor, languageId, editorId, logFunction, worker, monaco);
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function init_($this) {
  try {
    $this.connectWorker(new AglTokenizerByWorkerMonaco($this.r4u_1, $this.agl));
    // Inline function 'net.akehurst.language.editor.common.objectJS' call
    var o = {};
    // Inline function 'net.akehurst.language.editor.browser.monaco.AglEditorMonaco.init_.<anonymous>' call
    o.base = 'vs';
    o.inherit = false;
    // Inline function 'kotlin.emptyArray' call
    o.rules = [];
    var themeData = o;
    $this.s4u_1.defineTheme(Companion_getInstance_0().i4u_1, themeData);
    // Inline function 'net.akehurst.language.editor.common.objectJSTyped' call
    var o_0 = {};
    // Inline function 'net.akehurst.language.editor.browser.monaco.AglEditorMonaco.init_.<anonymous>' call
    o_0.id = $this.languageIdentity;
    $this.s4u_1.register(o_0);
    $this.s4u_1.setModelLanguage($this.r4u_1.getModel(), $this.languageIdentity);
    $this.s4u_1.setTheme(Companion_getInstance_0().i4u_1);
    var tmp = $this.languageIdentity;
    var tmp_0 = $this.workerTokenizer;
    $this.s4u_1.setTokensProvider(tmp, isObject(tmp_0) ? tmp_0 : THROW_CCE());
    $this.s4u_1.registerCompletionItemProvider($this.languageIdentity, new AglCompletionProviderMonaco($this.agl));
    $this.v4u(AglEditorMonaco$init_$lambda($this));
    var resizeObserver = new ResizeObserver(AglEditorMonaco$init_$lambda_0($this));
    resizeObserver.observe($this.q4u_1);
  } catch ($p) {
    if ($p instanceof Error) {
      var t = $p;
      console.error(t.message);
    } else {
      throw $p;
    }
  }
}
function update($this) {
  if ($this.doUpdate) {
    $this.workerTokenizer.reset();
    window.clearTimeout($this.u4u_1);
    var tmp = $this;
    var tmp_0 = window;
    tmp.u4u_1 = tmp_0.setTimeout(AglEditorMonaco$update$lambda($this), 500);
  }
}
function onResize($this, entries) {
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = entries.length;
  while (inductionVariable < last) {
    var element = entries[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'net.akehurst.language.editor.browser.monaco.AglEditorMonaco.onResize.<anonymous>' call
    if (element.target == $this.q4u_1) {
      $this.r4u_1.layout();
    }
  }
}
function AglEditorMonaco$init_$lambda(this$0) {
  return function (it) {
    update(this$0);
    return Unit_getInstance();
  };
}
function AglEditorMonaco$init_$lambda_0(this$0) {
  return function (entries) {
    onResize(this$0, entries);
    return Unit_getInstance();
  };
}
function AglEditorMonaco$update$lambda(this$0) {
  return function () {
    this$0.workerTokenizer.acceptingTokens = true;
    this$0.processSentence();
    return Unit_getInstance();
  };
}
function AglEditorMonaco$onChange$lambda(this$0, $handler) {
  return function (event) {
    var text = this$0.u1p();
    $handler(text);
    return Unit_getInstance();
  };
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function getLineTokensByScan($this, line, pState) {
  var state = pState instanceof AglLineStateMonaco ? pState : THROW_CCE();
  var proc = $this.agl.languageDefinition.processor;
  var nextLineNumber = state.lineNumber + 1 | 0;
  if (!(null == proc)) {
    var text = state.leftOverText + line;
    var leafs = proc.scan(text);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(leafs, 10));
    var tmp0_iterator = leafs.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.editor.browser.monaco.AglTokenProvider.getLineTokensByScan.<anonymous>' call
      tmp$ret$0 = new AglTokenProvider$getLineTokensByScan$tokens$1$1($this, item);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    var tokens = tmp0_mapTo;
    var tmp;
    if (leafs.y()) {
      tmp = new AglLineStateMonaco(nextLineNumber, text);
    } else {
      var lastLeaf = last(leafs);
      var endOfLastLeaf = lastLeaf.location.column + lastLeaf.location.length | 0;
      // Inline function 'kotlin.text.substring' call
      var tmp0_substring = line.length;
      // Inline function 'kotlin.js.asDynamic' call
      var leftOverText = line.substring(endOfLastLeaf, tmp0_substring);
      tmp = new AglLineStateMonaco(nextLineNumber, leftOverText);
    }
    var endState = tmp;
    return new AglTokenProvider$getLineTokensByScan$1(endState, tokens);
  } else {
    return Companion_getInstance_1().NO_TOKENS(nextLineNumber);
  }
}
function getLineTokensByParse($this, line, pState) {
  var state = pState instanceof AglLineStateMonaco ? pState : THROW_CCE();
  var nextLineNumber = state.lineNumber + 1 | 0;
  var sppt = ensureNotNull($this.agl.sppt);
  var leafs = sppt.tokensByLine(state.lineNumber);
  if (!(null == leafs)) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(leafs, 10));
    var tmp0_iterator = leafs.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.editor.browser.monaco.AglTokenProvider.getLineTokensByParse.<anonymous>' call
      tmp$ret$0 = new AglTokenMonaco($this.tokenPrefix + item.name, item.location.column);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    var tokens = tmp0_mapTo;
    var tmp = new AglLineStateMonaco(nextLineNumber, '');
    var tmp$ret$3;
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp$ret$3 = copyToArray(tokens);
    return new AglLineTokensMonaco(tmp, tmp$ret$3);
  } else {
    return Companion_getInstance_1().NO_TOKENS(nextLineNumber);
  }
}
function AglTokenizerByWorkerMonaco$decorateLine$lambda(it) {
  return 'monaco_' + it;
}
//region block: post-declaration
setMetadataFor(BuildConfig_0, 'BuildConfig', objectMeta);
setMetadataFor(AglCompletionProviderMonaco$provideCompletionItems$cil$1$1, VOID, classMeta);
setMetadataFor(AglCompletionProviderMonaco$provideCompletionItems$1, VOID, classMeta);
setMetadataFor(AglCompletionProviderMonaco, 'AglCompletionProviderMonaco', classMeta);
setMetadataFor(Monaco, 'Monaco', interfaceMeta);
setMetadataFor(Companion, 'Companion', objectMeta);
setMetadataFor(AglEditorMonaco, 'AglEditorMonaco', classMeta);
setMetadataFor(AglLineStateMonaco, 'AglLineStateMonaco', classMeta);
setMetadataFor(AglTokenMonaco, 'AglTokenMonaco', classMeta);
setMetadataFor(AglLineTokensMonaco, 'AglLineTokensMonaco', classMeta);
setMetadataFor(Companion_0, 'Companion', objectMeta);
setMetadataFor(AglTokenProvider$getLineTokensByScan$tokens$1$1, VOID, classMeta);
setMetadataFor(AglTokenProvider$getLineTokensByScan$1, VOID, classMeta);
setMetadataFor(AglTokenProvider, 'AglTokenProvider', classMeta);
setMetadataFor(ModelDecorationOptions, 'ModelDecorationOptions', classMeta);
setMetadataFor(AglTokenizerByWorkerMonaco, 'AglTokenizerByWorkerMonaco', classMeta, VOID, [AglTokenizerByWorker]);
//endregion
//region block: exports
var BuildConfig = {getInstance: BuildConfig_getInstance};
export {
  BuildConfig,
  AglCompletionProviderMonaco,
  attachToMonaco,
  AglLineStateMonaco,
  AglTokenMonaco,
  AglLineTokensMonaco,
  AglTokenProvider,
  ModelDecorationOptions,
};
export {
  Monaco as a,
  attachToMonaco as b,
};
//endregion

//# sourceMappingURL=net.akehurst.language.editor-agl-editor-browser-monaco.mjs.map
